module.exports = __webpack_public_path__ + "img/gravity_logo.9b692b87.png";